<div class="container">
    <div class="option-wrapper">
        <div class="option-head">
            <h1>Custom Countdown</h1>
        </div>
        <div class="option-content">
            <div class="left-option">
                <div class="card" (click) = "onView()">
                    <div class="img-wrapper">
                        <img src="../../../assets/img/timer.png" alt="">
                    </div>
                    <div class="label-wrapper">
                        <p>View a custom countdown</p>
                    </div>
                </div>
            </div>

            <div class="right-option">
                <div class="card" (click) = "onCreate()">
                    <div class="img-wrapper">
                        <img src="../../../assets/img/timer.png" alt="">
                    </div>
                    <div class="label-wrapper">
                        <p>Create a custom countdown</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>